<template>
  <div id="home">
    <el-container id="home" >
        <div v-if="device==='mobile'&& isCollapse==false" class="drawer-bg" @click="handleClickOutside" />
        <el-aside width="auto" :class="{mobile:device=='mobile',hideSidebar:isCollapse && device=='mobile'}">
          <div class="logo" :class="{collapse:isCollapse}">
              <!-- <div class="logoImg">
                  <img :src="'./static/images/'+logo">
              </div> -->
              <span class="sysName">{{sysName}}</span>
          </div>
          <div class="menu" :class="{collapse:isCollapse}" :style="{width:isCollapse?0:'260px'}">
          
            <el-menu ref='menu' :default-active="menuIndex" class="el-menu-vertical-demo" :collapse="isCollapse"  @select="handleSelect"  >
              <menulist :list="menu"></menulist>
            </el-menu>
            <chatList ref="chatList"></chatList>
              
          </div>
          
        </el-aside>
        <el-container>
            <el-header height='56px'>
                <div class="left-btn">
                  <el-tooltip class="item" effect="dark" :content="isCollapse?'展开菜单':'收缩菜单'" placement="bottom">
                    <i :class="isCollapse? 'el-icon-s-unfold':'el-icon-s-fold' " @click="collapseMenu"> </i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="开启新对话" v-if="isCollapse" placement="bottom">
                    <i class="el-icon-circle-plus-outline" @click="handleNewChat"></i>
                  </el-tooltip>
                </div>
                <div class="right">
                     <el-avatar icon="el-icon-user-solid" :src="user.avatar"></el-avatar>
                     <div class="userInfo-menu">
                        <el-dropdown @command="handleCommand">
                            <span class="el-dropdown-link">
                                {{user.nick}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu class="home-dropdown" slot="dropdown">
                              
                                <el-dropdown-item :command="'changeTenant_'+item.id" v-for="item in tenants" :key="item.id"> 
                                  {{ item.name }} 
                                  <i v-if="item.id==tenantId" class="checked el-icon-success" />
                                </el-dropdown-item>
                                <el-dropdown-item command="updPwd" divided>修改密码</el-dropdown-item>
                                <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    
                     </div>
                </div>
            </el-header>
            <el-main>
                <transition name="el-fade-in">
                  <keep-alive >
                    <router-view :key="key"></router-view>
                  </keep-alive>
                </transition>
            </el-main>
        </el-container>
    </el-container>
    <el-dialog title="修改密码"  :visible.sync="editPassWordVisible" :close-on-press-escape="false" :show-close="user.flag!==1" :close-on-click-modal="false" @close="$refs['editFrom'].resetFields();" width='300px'>
        <el-form  :model="editFrom" :rules="editRules"  ref="editFrom">
            <el-form-item label="" prop="oldPasswd">
                <el-input v-model="editFrom.oldPasswd" type="password" placeholder="原密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="newPasswd">
                <el-input v-model="editFrom.newPasswd" type="password" placeholder="新密码"></el-input>
            </el-form-item>
            <el-form-item label="" prop="confirmPasswd">
                <el-input v-model="editFrom.confirmPasswd" type="password" placeholder="确认新密码"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="editPassWordVisible = false" >取 消</el-button>
            <el-button type="primary" @click="updPwdSubmit">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { menu } from '../config/config';
import {encrypt} from '@/utils/rsaEncrypt'
import { mapState } from 'vuex'
import { logout, modifyAccount } from '@/apis/oms/common'
import ResizeMixin from '@/mixins/ResizeHandler'
import chatList from './chatList'

export default {
  name: 'home',
  components: {
    menulist: resolve => { require(['../components/menu.vue'], resolve) },
    chatList
  },
 
  mixins: [ResizeMixin],
  data() {
    var chkConfirmPasswd = (rule, value, callback) => {
      if (this.editFrom.newPasswd !== this.editFrom.confirmPasswd) {
        callback(new Error('确认新密码错误'));
      } else {
        callback();
      }
    }

    return {
      logo: process.env.VUE_APP_LOGO,
      msg: 'home',
      menu: [],
      menuIndex: "",
      menuName: "",
      //isCollapse: false,
      editFrom: {
        oldPasswd: "",
        newPasswd: "",
        confirmPasswd: "",
      },
      editRules: {
        oldPasswd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPasswd: [{ required: true, message: "请输入新密码", trigger: "blur" }],
        confirmPasswd: [
          { required: true, message: "请输入确认新密码", trigger: "blur" },
          { validator: chkConfirmPasswd, trigger: 'blur' }
        ]
      },
      editPassWordVisible: false,
    }
  },
  computed: {
    ...mapState({
      sysName: state => state.common.setting.sysName,
      dataDict: state => state.common.dataDict,
      user: state => state.userInfo.user,
      tenants: state => state.userInfo.tenants,
      tenantId: state => state.userInfo.tenantId,
      isCollapse: state => state.common.isCollapse,
      device: state => state.common.device,
      includedComponents: state => state.common.cachedViews
    }),
    key() {
      return this.$route.path
    }
    
  },
  watch: {
    '$route'(to, from) {
      let path = to.path;
      let menuItem = this.getMenu(path);
      if (menuItem != null && menuItem.id != this.menuIndex) {
        this.menuIndex = menuItem.id;
        this.setCurMenu(menuItem);
      }
    }
  },
  created() {
    console.log(this.sysName)
    this.menu = menu.OMSMenu;
    // this.$store.dispatch('update_cachedViews', this.menu.map(v => v.name)).then(res => { 
    //   console.log('设置需要缓存的页面')
    // })
    // if (this.user.roles == '0') {
    //   this.menu = menu.OMSMenu;
    // } else {
    //   this.menu = menu.schoolMenu;
    // }

    var path = this.$route.path;
    if (path.substring(path.length - 1) == "/") {
      path = path.substring(0, path.length - 1);

    }
    let menuItem = this.getMenu(path);
    if (menuItem != null) {
      this.menuIndex = menuItem.id;
      this.setCurMenu(menuItem);
    } else {
      menuItem = this.getFirstMenu();
      this.menuIndex = menuItem.id;
      this.setCurMenu(menuItem);
      this.$router.push({ path: menuItem.path });
    }


  },
  methods: {
    handleSelect(key, keyPath) {
      let curMenu = this.menu;
      for (let id of keyPath) {
        //如果是选中的结点
        if (id === key) {
          for (let item of curMenu) {
            if (item.id === id) {
              this.setCurMenu(item);
              this.$router.push({ path: item.path });
            }
          }
        } else {
          for (let item of curMenu) {
            if (item.id === id) {
              curMenu = item.children;
              break;
            }
          }
        }
      }
    },
    collapseMenu() {
      this.$store.dispatch('update_isCollapse', this.isCollapse ? false : true)
      // this.isCollapse = this.isCollapse ? false : true;
    },
    handleCommand(command) {
      if (command === "logOut") {
        this.logOut();
      } else if (command === "updPwd") {
        this.updPwd();
      } else if (command.indexOf('changeTenant_') > -1) { 
        let id = command.split('_')[1];
        if (id != this.tenantId) {
          let opt = this.tenants.find(v => { return v.id == id })
          if (opt) {
            this.$confirm('是否切换租户?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$store.dispatch('update_tenant', opt).then(res => {
                location.reload()
              })
            }).catch(() => {
            });
          }
        }
      }

    },
    logOut() {
      var loginUrl = '/login';
      //var loginUrl = '/login/' + this.$$dataDict.loginType[this.identity];
      this.$confirm('是否退出系统?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        
        logout().then(data => { 
          this.$store.dispatch('remove_userinfo').then(() => {
            location.reload()
          });
        })
        // logout({
        //   isLoadingShow: true,
        //   fn: data => {
        //     this.$store.dispatch('remove_userinfo').then(() => {
        //       this.$router.push({ path: loginUrl });
        //     });
        //   }
        // })

      }).catch(() => {
      });
    },
    updPwd() {
      this.editFrom = {
        oldPasswd: "",
        newPasswd: "",
        confirmPasswd: "",
      };
      this.editPassWordVisible = true;
    },
    updPwdSubmit() {
      this.$refs['editFrom'].validate((valid) => {
        if (valid) {
          this.$confirm('是否确认修改密码?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            
            modifyAccount({
              oldPasswd: encrypt(this.editFrom.oldPasswd),
              newPasswd:encrypt(this.editFrom.newPasswd),
            }).then(data => { 
              this.$message.success('密码修改成功！')
              this.editPassWordVisible = false;
            })
          }).catch(() => {
          });
        }
      });
    },
    getMenu(path, subMenu) {
      let menuItem = null;
      if (!subMenu) {
        subMenu = this.menu;
      }
      for (let item of subMenu) {
        if (item.children && item.children.length > 0) {
          let childrenMenu = this.getMenu(path, item.children)
          if (childrenMenu != null) {
            menuItem = childrenMenu;
            break;
          }

        } else {
          if (path.indexOf(item.path)==0) {
            menuItem = item;
            break;
          }
        }
      }
      return menuItem
    },
    getFirstMenu(subMenu) {
      let menuItem = null;
      if (!subMenu) {
        subMenu = this.menu;
      }
      if (subMenu[0].children && subMenu[0].children.length > 0) {
        let childrenMenu = this.getFirstMenu(subMenu[0].children)
        if (childrenMenu != null) {
          menuItem = childrenMenu;
        }
      } else {
        menuItem = subMenu[0]
      }
      return menuItem;
    },
    setCurMenu(menu) {
      this.$store.dispatch('update_selectedMenu', menu).then(() => {
        //console.log('设置当前菜单', menu)
      })
    },
    handleClickOutside() {
      this.$store.dispatch('update_isCollapse', true)
    },
    loadHistory() { 
      console.log('来来来')
    },
    handleNewChat() { 
      this.$refs.chatList.newChat();
    }

  }
}
</script>

<style lang="scss" >
@import '../theme-variables.scss';
#home{
    width: 100%;
    height: 100%;
    .el-aside{
        display: flex;
        flex-direction: column;
        background-color: #f5f5f5;
        transition: width 0.5s ease-in-out;
        .logo{
            display: flex;
            align-items: center;
            color:#000;
            padding: 15px 20px;
            text-align: center;
            box-sizing: border-box;
             width: 260px;
             overflow: hidden;  
            justify-content: flex-start;
            transition: width 0.5s ease-in-out, padding 0.5s ease-in-out;
            img{
                width: 36px;
                max-width: 27px;
            }
            .logoImg{
                margin: 0 10px;
                background: #fff;
                width:40px;
                height:40px;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex: 0 0 auto;
            }
            .sysName{
                padding-right: 10px;
                font-size: 18px;
                opacity: 1;
                transition: opacity 0.3s ease-in-out;
                 white-space: nowrap;
            }
        }
        .collapse{
          // img{
          //     width:50px
          // }
          width: 0;
          padding: 15px 0;
          transition: width 0.5s ease-in-out;
          overflow: hidden;
          .sysName{
            opacity: 0;               /* 文字淡出，而不是瞬间消失 */
            white-space: nowrap;
          }

        }
        
        .menu{
            flex: 1;
            overflow: auto;
            background: #f5f5f5;
            display: flex;
            flex-direction: column;
            transition: width 0.5s ease-in-out;
            .el-scrollbar{
                height: 100%;
                .scrollbar-wrapper {
                    overflow-x: hidden !important;
                }
                
                // .el-scrollbar__thumb{
                //     background-color: rgba(255,255,255,0.5);
                // }
            
                // .el-scrollbar__thumb:hover {
                //     background-color: rgba(255,255,255,0.7);
                // }
            }
            .el-menu-vertical-demo:not(.el-menu--collapse){
                width: 260px;
            }
            .el-menu{
                background: inherit;
                border:none;
                // i,svg{
                //     color:$--color-black;
                //     fill:$--color-black;
                // }
                // span{
                //     color:$--color-black
                // }
                .el-menu-item{
                  height: 28px;
                  line-height: 28px;
                  margin: 10px 10px;
                  border-radius: 20px;
                  padding: 0 10px !important;
                }
                .el-menu-item:hover{
                    background-color:#E5E7EA;
                    //box-shadow:5px 5px 30px rgba(0,0,0,0.16);
                   
                }
                .el-menu-item:focus{
                    background-color: inherit;
                }
                .svg-icon{
                  width: 24px;
                  text-align: center;
                  font-size: 14px;
                  vertical-align: middle;
                  margin: 0 auto;
                }
                .el-submenu__title:hover{
                    background-color:#E5E7EA;
                    //box-shadow:5px 5px 30px rgba(0,0,0,0.16);
                }
                .el-menu-item.is-active{
                    background-color:#e4edfe;
                    color:#3964fe;
                   //box-shadow:5px 5px 30px rgba(0,0,0,0.16);
                }

            }
            .el-menu--collapse{
                width:0;
                overflow: hidden;
                .el-menu-item {
                    //height: 100px;
                    box-sizing: border-box;
                    .el-tooltip{
                        display: flex !important;
                        justify-content: center;
                        align-items: center;
                        i{
                            font-size: 20px;
                        }
                    }
                }
                .el-submenu{
                    .el-submenu__title{
                        //height: 100px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        i{
                            font-size: 20px;
                        }
                    }
                }
            }

           
            
        }
       
    }
    .mobile{
      position: fixed;
      height: 100%;
      top:0;
      bottom:0;
      left:0;
      z-index: 1001;
      overflow: hidden;
      box-shadow: rgba(0, 0, 0, 0.16) 6px 0px 16px 0px
    }
    .hideSidebar{
      display: none;
    }
    .drawer-bg {
      background: #000;
      opacity: 0.3;
      width: 100%;
      top: 0;
      height: 100%;
      position: absolute;
      z-index: 999;
    }
    .el-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: $--color-white;
        //box-shadow:3px 0px 9px rgba(172,200,219,0.46);
        border-bottom: solid #eeeeee 1px;
        .left-btn{
            display: flex;
            align-items: center;
            i{
                font-size: 26px;
                color:#A8ACB9;
                cursor: pointer;
                border-radius: 50%;
                padding: 5px;
            }
            i:hover{
              background: #E5E7EA;
            }

        }
        .right{
            
            display: flex;
            align-items: center;
            .el-dropdown{
                color:$--color-text-secondary;
            }
            .el-avatar{
                width:30px;
                height: 30px;
                line-height: 30px;
            }
            .userInfo-menu{
                margin-left: 10px;
                .el-dropdown{
                    cursor: pointer;
                    
                }
            }
        }

    }
    
}

.home-dropdown{
  .checked{
    color:$--color-success;
  }
}
</style>